import React, {FC} from "react"

interface Props {
    saveStatus: 'not_changed' | 'changed' | 'saved'
    lastSavedTime: Date | null
}

export const PartSaveStatus: FC<Props> = ({
                                              saveStatus,
                                              lastSavedTime,
                                          }) => {
    return (
        <div className={`save-status ${saveStatus}`}>
            {saveStatus === 'not_changed' && 'Not changed'}
            {saveStatus === 'changed' && 'Changed'}
            {saveStatus === 'saved' && lastSavedTime && `Saved at ${lastSavedTime.toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            })}`}
        </div>
    )
}
